import set from "@rill/set";
import rill from "rill";

import getCommunityChat from "./community-chat.controller.js";

const CommunityChat = (app) => {
  app.at(
    "/community-chat/*",
    rill()
      .use(set("heading", ["Coaching", "CommunityChat"]))
      .setup((app) => {
        app.get("/", getCommunityChat);
      })
  );
};

export default CommunityChat;
